import { Component, Event, EventEmitter, JSX, Prop, h } from '@stencil/core'

import { BillingType, CheckoutData, InstallmentFrequency } from './air-checkout.types'

@Component({
  tag: 'air-checkout',
  styleUrl: 'air-checkout.scss',
  shadow: true,
})
export class AirCheckout {
  /** Emits air-edit custom event */
  @Event({ eventName: 'air-edit' }) edit!: EventEmitter<void>

  /** Receives checkout data */
  @Prop() data!: CheckoutData

  private handleEditClick = (event: MouseEvent): void => {
    event.preventDefault()
    this.edit.emit()
  }

  private setMonthly(): string {
    return this.data.installmentFrequency === InstallmentFrequency.Yearly
      ? InstallmentFrequency.Yearly
      : InstallmentFrequency.Monthly
  }

  private dueOnPurchaseFrequency(): string {
    if (this.data.installmentFrequency === InstallmentFrequency.Yearly) {
      return '(1 year upfront)'
    }
    const frequency = Math.round(this.data.downpayment / this.data.installmentPayment)
    return `(${frequency} months upfront)`
  }

  private getCollectedBy(): string {
    return this.data.billingType === BillingType.Brokerage
      ? this.data.brokerage
      : this.data.underwriter
  }

  private isCollectedByAgent(): boolean {
    return this.data.billingType === BillingType.Direct && !this.data.collectPayment
  }

  private amountFormat(number: number): string {
    return new Intl.NumberFormat('us-US', { style: 'currency', currency: 'USD' }).format(number)
  }

  // TODO: https://github.com/briza-insurance/briza-air/issues/415
  private getLogoUrl(): string | undefined {
    return
  }

  render(): JSX.Element {
    return (
      <div class="checkout">
        <img class="logo" src={this.getLogoUrl()} alt={this.data.underwriter} />
        <h3 class="name">{this.data.underwriter}</h3>
        <span class="title">{this.data.product}</span>
        <p class="payment">
          <span>
            {this.data.installmentFrequency} - {this.amountFormat(this.data.downpayment)}/
            {this.setMonthly()}
          </span>
          <a href="#" class="edit" onClick={this.handleEditClick}>
            Edit
          </a>
        </p>
        <p class="purchase">
          <span>Due on purchase</span>
          <span>
            {this.amountFormat(this.data.downpayment)}{' '}
            {this.data.collectPayment
              ? this.dueOnPurchaseFrequency()
              : `Collected by ${this.getCollectedBy()}`}
          </span>
        </p>
        <air-divider class="divider"></air-divider>
        <p class="cost">
          <span>Policy cost</span>
          <span>{this.amountFormat(this.data.downpayment)}</span>
        </p>
        {this.isCollectedByAgent() && (
          <p class="fee">
            <span>Collected by Agent after checkout</span>
            <span>{this.amountFormat(this.data.downpayment)}</span>
          </p>
        )}
        <p class="total">
          <span>Checkout total</span>
          <span>
            {this.isCollectedByAgent()
              ? this.amountFormat(0)
              : this.amountFormat(this.data.downpayment)}
          </span>
        </p>
      </div>
    )
  }
}
